<button type="button" class="user-menu-trigger" [matMenuTriggerFor]="userMenu"
  [attr.aria-label]="'Account menu for ' + displayName()" [title]="displayName()">
  <span class="user-menu-label">{{ displayName() }}</span>
  <mat-icon class="user-menu-mobile-icon" aria-hidden="true">account_circle</mat-icon>
  <mat-icon class="user-menu-chevron" aria-hidden="true">arrow_drop_down</mat-icon>
</button>

<mat-menu #userMenu="matMenu" class="phms-user-menu" xPosition="before" aria-label="Account">
  <div class="user-menu-profile">
    <span class="user-menu-avatar" aria-hidden="true">{{ initials() }}</span>
    <div class="user-menu-identity">
      <span class="user-menu-caption">Signed in as</span>
      <strong>{{ displayName() }}</strong>
      @if (secondaryLabel()) {
        <span class="user-menu-secondary">{{ secondaryLabel() }}</span>
      }
    </div>
  </div>
  <div class="user-menu-divider" role="separator"></div>
  <button mat-menu-item class="user-menu-signout" (click)="logout()">
    <mat-icon aria-hidden="true">logout</mat-icon>
    <span>Sign out</span>
  </button>
</mat-menu>
